export default "__VITE_ASSET__CeIPFSRT__"